import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { SdkClientCreateInput } from '../generated/globalTypes';
import { createSdkClientMutation, createSdkClientMutationVariables } from '../generated/createSdkClientMutation';
import { sdkClientFieldsFragment } from '../models/SdkClient';

/**
 * Get a callback to create a SdkClient in the store.
 */
export function useCreateSdkClientCallback(): [(model: SdkClientCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createSdkClientMutation, createSdkClientMutationVariables>(
        gql`
            mutation createSdkClientMutation ($model: SdkClientCreateInput!) {
                createSdkClient(model: $model) {
                    ...sdkClientFields
                }
            }

            ${sdkClientFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: SdkClientCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
